export const appCheckCircleFilledIcon = {
  data: `<svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
>
    <path
            d="M7 0C3.13 0 0 3.13 0 7C0 10.87 3.13 14 7 14C10.87 14 14 10.87 14 7C14 3.13 10.87 0 7 0ZM5.83 10.08L2.91 7.16L3.68 6.39L5.83 8.54L10.39 3.98L11.16 4.75L5.83 10.08Z"
            fill="currentColor"
    />
</svg>

`,
  name: 'check-circle-filled',
};
